import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AddressCargo } from 'src/app/core/interfaces/addressCargo';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { Destination } from 'src/app/core/interfaces/destination';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { Utils } from 'src/app/core/resources/utils';
import { Driver } from "src/app/core/models/driver";
import { Permission } from 'src/app/core/resources/permission';
import { ServiceType } from 'src/app/core/interfaces/serviceType';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { ModalSelectionMapComponent } from 'src/app/shared/modal-selection-map/modal-selection-map.component';
import { Fingerprint } from 'src/app/core/interfaces/fingerprint';
import { DateFormatPipe } from 'src/app/core/pipe/dateFormat.pipe';
import { LogisticTime } from 'src/app/core/interfaces/durationTime';
import { DateManager } from 'src/app/core/managers/date.manager';
@Component({
  selector: 'app-cargo-tracking-states-history',
  templateUrl: './cargo-tracking-states-history.component.html',
  styleUrls: ['./cargo-tracking-states-history.component.scss'],
  providers: [DateFormatPipe]
})
export class CargoTrackingStatesHistoryComponent {
  @Input() driver: Driver;
  @Input() vehicle: Vehicle;
  @Input() cargo: Cargo;
  @Input() historyNoveltyPoints = [];
  @Input() historyCargoLogisticTimes = { origin: {}, destination: {} };
  @Output() emitToParent: EventEmitter<any> = new EventEmitter();
  public showDetail: boolean = false;
  noveltyUsers = [
    { value: "MANUAL_POINTS", alias: "Reportes Manuales", icon: "../../../../assets/svg/icons/icon-correct.svg", checked: true },
    { value: "SATRACK", alias: "Satrack", icon: "../../../../assets/svg/icons/satrack_logo.png", checked: true },
  ]
  permission = Permission;
  filteredHistoryNoveltyPoints = [];
  typeTrackingSelected: string = 'Todos';
  constructor(
    public utils: Utils,
    public snackBarService: SnackBarService,
    public matDialog: MatDialog,
    public dateFormatPipe: DateFormatPipe
  ) { }
  public get listOrigins(): AddressCargo[] {
    if (
      this.utils.isDefined(this.cargo) &&
      this.utils.isDefined(this.cargo.cargoFeature) &&
      this.utils.isDefined(this.cargo.cargoFeature.uploadDownload) &&
      this.utils.isDefined(this.cargo.cargoFeature.uploadDownload.origin) &&
      this.utils.isDefined(this.cargo.cargoFeature.uploadDownload.origin.addresses)
    ) {
      return this.cargo.cargoFeature.uploadDownload.origin.addresses;
    } else {
      return [];
    }
  }

  public get listDestinations(): Destination[] {
    if (
      this.utils.isDefined(this.cargo) &&
      this.utils.isDefined(this.cargo.cargoFeature) &&
      this.utils.isDefined(this.cargo.cargoFeature.uploadDownload) &&
      this.utils.isDefined(this.cargo.cargoFeature.uploadDownload.destination)
    ) {
      return this.cargo.cargoFeature.uploadDownload.destination;
    } else {
      return [];
    }
  }

  get isEscortedService(): boolean {
    return this.utils.isEscortedService(this.cargo);
  }

  get isSatelliteLockService(): boolean {
    return this.utils.isSatelliteLockService(this.cargo);
  }
  get isTransportService(): boolean {
    return this.utils.isTransportService(this.cargo);
  }

  /**
  * This method show the icon according to the state of the address.
  * @param {AddressCargo} address (AddressCargo) is the address to modify.
  * @returns {boolean} (boolean) return if show or hide the icon.
  */
  public showIconByAddress(address: AddressCargo): boolean {
    // llego a recoger - "Arrived to pickup cargo"
    // servicio recogido - "Pickup load"
    // llego a entregar - "Destination arrived"
    // entregó servicio - "Cargo unloaded"
    let showIcon = false;

    switch (address.state) {
      case "Pickup load":
      case "Cargo unloaded":
        showIcon = true;
        break;
    }

    return showIcon;
  }
  /**
  * This method set the status message of the address.
  * @param {AddressCargo} address (AddressCargo) is the address that needs to set the status message.
  * @returns {string} (string) returns the status message of the address.
  */
  public getDataByAddress(address: AddressCargo): string {
    // llego a recoger - "Arrived to pickup cargo"
    // servicio recogido - "Pickup load"
    // llego a entregar - "Destination arrived"
    // entregó servicio - "Cargo unloaded"
    let statusString = this.isEscortedService ? "El escolta está en camino" : this.isSatelliteLockService ? "El candado está en camino" : "El conductor está en camino";

    switch (address.state) {
      case "Arrived to pickup cargo":
        statusString = this.isEscortedService ? "El escolta llegó al punto de origen" : this.isSatelliteLockService ? "El candado llegó al punto de origen" : "El conductor llegó a recoger el servicio";
        break;
      case "Pickup load":
        statusString = this.isEscortedService ? "El escolta salió del punto de origen" : this.isSatelliteLockService ? "El candado salió del punto de origen" : "El conductor ha recogido el servicio";
        break;
      case "Destination arrived":
        statusString = this.isEscortedService ? "El escolta llegó al punto de destino" : this.isSatelliteLockService ? "El candado llegó al punto de destino" : "El conductor llegó a entregar el servicio";
        break;
      case "Cargo unloaded":
        statusString = this.isEscortedService ? "El escolta terminó el servicio" : this.isSatelliteLockService ? "El candado terminó el servicio" : "El conductor ha entregado el servicio";
        break;
    }

    return statusString;
  }
  /**
  * This method emits to parent actions according to the event that arrives in the parameters.
  * @param {Cargo} $event (Cargo) is the information of the associate load.
  */
  public onLoadedEvidences($event: Cargo): void {
    if ($event && $event.id) {
      this.emitToParent.emit({
        name: 'refreshCargoData',
        data: $event
      });
    } else {
      this.emitToParent.emit({
        name: 'getCargoDetail',
        data: this.cargo.consecutive.toString()
      });
    }
  }

  get isSomeNoveltyUserPoint(): boolean {
    let filteredArray = [...this.noveltyUsers];
    filteredArray.shift();
    return this.historyNoveltyPoints && !!this.historyNoveltyPoints.length &&
      this.historyNoveltyPoints.some(novelty =>
        novelty.data && novelty.data.fingerprint && novelty.data.fingerprint.userName
        && filteredArray.some(userName => userName.value === novelty.data.fingerprint.userName)
      )
  }
  /**
  * This method check if the user have the checked option to visualize the checkbox options of tracking.
  * @param {string} userName (string) is the user that wants to consult.
  * @returns {boolean} (boolean) returns if the user is checked or not.
  */
  isUserNameChecked(userName: string): boolean {
    let filteredArray = [...this.noveltyUsers];
    filteredArray.shift();
    if (filteredArray.some(noveltyUser => noveltyUser.value === userName)) {
      let noveltyUser = filteredArray.filter(noveltyUser => noveltyUser.value === userName)
      return !!noveltyUser[0] && noveltyUser[0].checked;
    }
    return this.noveltyUsers[0].checked;
  }
  /**
  * This method set the icon shown according to the match of the username with the novelty user.
  * @param {string} userName (string) is the user to compare.
  * @returns {string} (string) returns the novelty icon.
  */
  getNoveltyIcon(userName: string): string {
    let filteredArray = [...this.noveltyUsers];
    filteredArray.shift();
    if (filteredArray.some(noveltyUser => noveltyUser.value === userName)) {
      let noveltyUser = filteredArray.filter(noveltyUser => noveltyUser.value === userName)
      if (!!noveltyUser[0]) return noveltyUser[0].icon;
    }
    return this.noveltyUsers[0].icon;
  }

  getFingerprintDescription(address: AddressCargo, addressType: 'origin' | 'destination', type: 'startDate' | 'endDate', indexAddress: number, indexDownload?: number): string {
    let history: LogisticTime[] = null;
    if (addressType === 'origin')
      history = this.utils.getNestedValue(this.historyCargoLogisticTimes, `origin.${indexAddress}.${type}`);
    else
      history = this.utils.getNestedValue(this.historyCargoLogisticTimes, `destination.${indexDownload}.${indexAddress}.${type}`);
    if (!history || !history.length) return '';
    const addressDurationTime = this.utils.getNestedValue(address, `durationTime.${type}`);
    if (!addressDurationTime) return '';
    const addressDate = DateManager.stringToDate(addressDurationTime);
    const fingerprintHistory = history.find(logisticTime => {
      const fingerprint = this.utils.getNestedValue(logisticTime, 'fingerprint');
      if (!fingerprint || !fingerprint.date || !fingerprint.userName || !fingerprint.userId) return false;
      const date = this.utils.getNestedValue(logisticTime, `durationTime.${type}`);
      if (!date) return false;
      return DateManager.isSame(date, addressDate, 'seconds');
    });
    if (!fingerprintHistory) return '';
    const fingerprint = this.utils.getNestedValue(fingerprintHistory, 'fingerprint');
    return `Registrado por: ${fingerprint.userName} (${fingerprint.userId})\nFecha: ${this.dateFormatPipe.transform(fingerprint.date, 'only-date')} ${this.dateFormatPipe.transform(fingerprint.date, 'time')}`;
  }

  public get enableStateTrackingAddresses() {
    return this.cargo && this.cargo.cargoFeature && this.cargo.cargoFeature.uploadDownload && this.cargo.cargoFeature.uploadDownload.origin && this.cargo.cargoFeature.uploadDownload.origin.addresses && this.cargo.cargoFeature.uploadDownload.origin.addresses.length && this.cargo.cargoFeature.uploadDownload.origin.addresses.every(address => address.state && address.state === 'Pickup load') && !this.cargo.startTripDate;
  }

  checkLocation(tracePoint) {
    const dialogConfig = new MatDialogConfig();
    const title = this.utils.getNestedValue(tracePoint, 'data.anomaly');
    const observation = this.utils.getNestedValue(tracePoint, 'data.observation');
    if (!tracePoint || !tracePoint.lat || !tracePoint.lng)
      return this.snackBarService.openSnackBar('No es posible acceder a la ubicación de esta novedad.', undefined, 'alert');

    dialogConfig.data = { initialValue: { address: title ? title : observation ? observation : 'Reporte de GPS', location: { lat: tracePoint.lat, lng: tracePoint.lng } } };
    dialogConfig.height = ModalEnum.MEDIUM_HEIGHT;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(ModalSelectionMapComponent, dialogConfig);
  }
}
